export const environment = {
  /**
   * マップの切り替え.
   *
   * - none : マップ使用しない
   * - osm : OpenStreetMap
   * - google : Google Map
   *    `index.html` に `<script src="https://maps.googleapis.com/maps/api/js?key=${GoogleMapApikey}" async defer></script>` を指定してください。
   */
  map: 'google',
  servicerApiUrl: 'https://nissan-mslab-adl4.com/vehicle',
  servicerApiUrls: [
    'https://nissan-mslab-adl4.com/vehicle',
    'http://localhost:8081'
  ],
  /**
   * タイトル.
   *
   * - 浪江/NATC(浪江同等) : Namie Mobility Service
   * - シャドーFMS/横浜 : Nissan Mobility Service
   */
  title: 'Mobility Service',
  /**
   * [システム]ダッシュボードAPIを取得する間隔（単位：ms）.
   * FMS/CMS の一覧を表示する間隔に影響する.
   *
   * - 浪江/NATC(浪江同等) : 10000
   * - シャドーFMS/横浜 : 1000
   */
  systemDashboardInterval: 1000,
  /**
   * シミュレート結果を確認する間隔（単位：ms）.
   */
  simulateResultInterval: 10000,
  /**
   * [システム] [休憩計画]ダッシュボードAPIを取得する間隔（単位：ms）.
   */
  systemRestPlanDashboardInterval: 10000,
  /**
   * [休憩計画] 需要の評価の色を変えるための値.
   */
  restPlanDemandCount: 10,
  /**
   * エリアインデックス.
   *
   * - 浪江/NATC(浪江同等) : 1
   * - シャドーFMS : 2
   * - 横浜 : 3
   */
  areaIndex: 3,
  /** エリアリスト. */
  red5ProliveStream : {
    red5ProUsername: 'red5pro-2023',
    red5ProPassword: 'rdFlvE4955',
    red5ProHost: 'hitachi.driverless-demo-adcloud.com',
    red5ProPort: 443,
    red5ProApp: 'live',
    red5ProMediaElementId: 'adash-red5pro-subscriber'
  },
  peerServerInfo : {
    peerHost: '',
    peerPort: 9001,
    peerpath: '/'
  },
  areas: [
    {
      name: 'NATC',
      areaId: 1,
      /** HUBのエリアID. */
      hubAreaId: 1,
      /** SPOKEのエリアID. */
      spokeAreaId: 2,
      /** マップ初期緯度. */
      lat: 35.445849800,
      /** マップ初期経度. */
      lon: 139.313523200,
      /** マップ初期ズーム. */
      zoom: 18,
      /** CMSに表示するユーザのログインID（正規表現）. */
      userPattern: '^U(0[0-9][0-9]|100)$',
      /** FMS 表示車両情報. */
      fmsVehicles:[
        {
          /**
           * カテゴリ.
           * title：タイトル
           * activeVehicleEnabled：稼働中車両有無（稼働中車両と座席占有状況の件数に該当する車両）
           */
          category: {
            title: '自動運転 Easy Ride（中心部）',
            activeVehicleEnabled: false
          },
          /**
           * 表示車両一覧.
           * vin：VIN番号
           * img：車両画像
           * controlEnabled：車両制御ボタン（サービスOFF、リクエストキャンセル、待機場所ボタン）の活性有無.
           */
          vehicles: [
          ]
        },
        {
          category: {
            title: '有人シャトル（中心部）',
            activeVehicleEnabled: true
          },
          vehicles: [
          ]
        },
        {
          category: {
            title: 'EVタクシー（周辺部）',
            activeVehicleEnabled: true
          },
          vehicles: [
          ]
        }
      ],
      /** ポリライン. */
      basePolylines: []
    },
    {
      name: '浪江',
      areaId: 3,
      hubAreaId: 3,
      spokeAreaId: 4,
      lat: 37.494338100,
      lon: 141.000402000,
      zoom: 15,
      userPattern: '^(U|G)([0-9]*[0-9][0-9][0-9])$',
      fmsVehicles:[
        {
          category: {
            title: 'サービス車両',
            activeVehicleEnabled: true
          },
          vehicles: [
          ]
        }
      ],
      basePolylines: []
    },
    {
      name: '横浜',
      areaId: 5,
      hubAreaId: null,
      spokeAreaId: 5,
      lat: 35.450939000,
      lon: 139.638361000,
      zoom: 15,
      userPattern: '^(U|N)(0[0-9][0-9]|100)$',
      fmsVehicles:[
        {
          category: {
            title: 'MSPF車両',
            activeVehicleEnabled: true
          },
          vehicles: [
          ]
        },
        {
          category: {
            title: '自動運転 Easy Ride',
            activeVehicleEnabled: false
          },
          vehicles: [
          ]
        }
      ],
      basePolylines: []
    },
    {
      name: '横浜',
      areaId: 5,
      hubAreaId: null,
      spokeAreaId: 5,
      lat: 35.450939000,
      lon: 139.638361000,
      zoom: 15,
      userPattern: '^(U|N)(0[0-9][0-9]|100)$',
      fmsVehicles:[
        {
          category: {
            title: 'サービス車両',
            activeVehicleEnabled: true
          },
          vehicles: [
          ]
        }
      ],
      basePolylines: []
    }
  ]
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts